import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {EmisorCFEDTO} from '../../models/dtos/EmisorCFEDTO';
import {EmisionCfeService} from '../services/emision-cfe.service';
import {KeycloakService} from 'keycloak-angular';
import {ERROR_INESPERADO, NO_HAY_DATOS_EMISOR_CFE_CON_ESTE_EMAIL} from '../../constants/EmisionCfeErrorCodes';

@Injectable()
export class MainContainerResolver implements Resolve<Observable<Array<EmisorCFEDTO>>>
{
  constructor(private emisionCfeService: EmisionCfeService, private keycloakService: KeycloakService)
  {

  }

  public resolve(): Observable<Array<EmisorCFEDTO>>
  {
    const email: string = this.keycloakService.getUsername();
    // @ts-ignore
    return this.emisionCfeService.obtenerEmisorCFE(email, null).subscribe(
      (emisoresCFEsDTOs: Array<EmisorCFEDTO>) =>
      {
        if (emisoresCFEsDTOs.length === 1)
        {
          localStorage.setItem("EMISOR",JSON.stringify(emisoresCFEsDTOs[0]));
          this.emisionCfeService.setEmisorCFEDTO(emisoresCFEsDTOs[0]);
          console.log('Se encontró un emisor CFE desde el MainContainerResolver.');
        }
      },
      (exception: any) =>
      {
        switch (exception.error.appErrorCode)
        {
          case NO_HAY_DATOS_EMISOR_CFE_CON_ESTE_EMAIL:
            console.log('No se encontró un emisor CFE desde el MainContainerResolver.');
            break;
          case ERROR_INESPERADO:
            console.log(exception.error.message);
            break;
          default:
            console.log('No se encontró un emisor CFE desde el MainContainerResolver.');
            break;
        }
      },
      () =>
      {

      });
  }
}
